import { render, staticRenderFns } from "./buildings.vue?vue&type=template&id=4bcbc334&scoped=true"
import script from "./buildings.vue?vue&type=script&lang=js"
export * from "./buildings.vue?vue&type=script&lang=js"
import style0 from "./buildings.vue?vue&type=style&index=0&id=4bcbc334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcbc334",
  null
  
)

export default component.exports